import { styled } from '$utils/theme'
import { Icon } from '$views/components/Icon'
import { rem } from 'polished'
import { Block } from '$views/components/Layout/Block'

export const StyledIcon = styled(Icon)`
  height: ${p => rem(p.theme.sizes.small)};
  width: ${p => rem(p.theme.sizes.small)}
  margin-right: ${p => rem(p.theme.sizes.none)};
`

export const StyledBlock = styled.div`
  text-align: center;
  :hover {
    cursor: pointer;
  }
`

export const ContainerMenu = styled(Block)`
  margin: ${rem(10)} ${p => rem(p.theme.sizes.tiny)} ${p => rem(p.theme.sizes.base)};
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 0.8fr;
`

export const WrapperMenu = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: ${p => p.theme.colors.white};
  z-index: 3;
`

export const WrapperAppMenu = styled.div`
  border-top: 1px solid ${p => p.theme.colors.lightGrey};
  width: 100%;
`

export const BannerApp = styled.div`
  border-top: 2px solid ${p => p.theme.colors.blue};
  width: 100%;
  background-color: ${p => p.theme.colors.xlightGrey};
  padding: ${p => rem(p.theme.sizes.tiny)};
`

export const StyledAppIcon = styled(Icon)`
  position: absolute;
  right: 0;
  top: 1px;
`



// WEBPACK FOOTER //
// ./src/views/components/AppMenu/AppMenu.style.ts